export default {
    'Background Image': "Image de fond",
    'Internal media storage is empty.': 'La mémoire interne du média est vide.',
    'Insert background image': 'Insérer une image de fond',
    'Remove background image': "Supprimer l'image de fond",
}